import { Component, OnInit } from '@angular/core';
import { Globals } from '../app/globals';

@Component({
  selector: 'app-logged-out-page',
  templateUrl: './logged-out-page.component.html',
  styleUrls: ['./logged-out-page.component.scss']
})
export class LoggedOutPageComponent implements OnInit {

  constructor(private _Globals: Globals) { }

   ngOnInit() {
        this._Globals.deleteAllStorage();
        this._Globals.deactivateAllModes();
   }

}
